import { Injectable } from '@angular/core';

export type eventData = {
  status: string;
  mobile_unit?: boolean;
  appointment?: string;
  datatime?: string;
  branch?: {
    // TALLER
    id?: string;
    name?: string;
    address?: string;
    city?: string;
    province?: string;
    postalCode?: string;
  };
  service_pretty?: string;
  msg?: string;
};
@Injectable({
  providedIn: 'root',
})
export class IFrameEventManagerService {
  private readonly parentOrigin = '*';

  sendMessage(message: eventData): void {
    if (!this.isInsideIframe()) {
      //USAGE Apache cordova inAppBrowser on iOS and android
      const payload = JSON.stringify(message);
      if ((window as any).webkit?.messageHandlers?.cordova_iab) {
        (window as any).webkit.messageHandlers.cordova_iab.postMessage(payload);
      } else if ((window as any).cordova_iab) {
        (window as any).cordova_iab.postMessage(payload);
      } else {
        console.warn('InAppBrowser message bridge not available');
      }
    } else window.parent.postMessage(message, this.parentOrigin);
  }

  sendStatus(status: string): void {
    this.sendMessage({
      status: status,
    });
  }

  sendSuccess(data: eventData): void {
    this.sendMessage({
      ...data,
      status: '200',
    });
  }

  sendCallCenter(): void {
    this.sendStatus('201');
  }

  sendInProgress(): void {
    this.sendStatus('202');
  }

  sendGeneralError(): void {
    this.sendStatus('500');
  }

  sendClientError(status: string | number): void {
    if (!String(status).startsWith('4')) {
      console.warn(`[IframeMessengerService] ${status} n'est pas un code 4XX.`);
    }

    this.sendStatus(String(status));
  }

  sendServerError(status: string | number): void {
    if (!String(status).startsWith('5')) {
      console.warn(`[IframeMessengerService] ${status} n'est pas un code 5XX.`);
    }

    this.sendStatus(String(status));
  }

  private isInsideIframe(): boolean {
    return window.parent !== window;
  }
}
